var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActiveMachine = function SvgActiveMachine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 7 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 7.601V1.4C0 .857.337.58.738.58c.166 0 .345.047.52.15l5.158 3.005c.392.226.584.439.584.767s-.192.537-.584.767L1.258 8.275c-.175.098-.354.15-.52.15C.337 8.424 0 8.146 0 7.6"
  })));
};
export default SvgActiveMachine;